"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHostSourcesFromRoles = getHostSourcesFromRoles;
exports.getSpeakerSourcesFromRoles = getSpeakerSourcesFromRoles;
var _StudioLogger = require("@studio/logger/StudioLogger");
var _Sources = require("@studio/constants/Sources");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var logger = new _StudioLogger.StudioLogger('broadcastRolesHelper');

/**
 * Extracts speaker sources from broadcastRoles, merged with live sources.
 * broadcastRoles is the source of truth that pre-populates users before they join.
 * If a matching source exists (by user ID), its title is used to reflect name changes.
 * Any extra users present in sources but not in broadcastRoles are appended.
 *
 * @param {Array} broadcastRoles - The array of broadcast role objects
 * @param {Array} speakerSources - Pre-filtered speaker sources from broadcastSources
 * @returns {Array} Merged array of source-shaped objects for speakers
 */
function getSpeakerSourcesFromRoles() {
  var broadcastRoles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var speakerSources = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return mergeRolesAndSources(broadcastRoles.filter(function (role) {
    return role.role === 'presenter';
  }), speakerSources);
}

/**
 * Extracts host sources from broadcastRoles, merged with live sources.
 * broadcastRoles is the source of truth that pre-populates users before they join.
 * If a matching source exists (by user ID), its title is used to reflect name changes.
 * Any extra users present in sources but not in broadcastRoles are appended.
 *
 * @param {Array} broadcastRoles - The array of broadcast role objects
 * @param {Array} hostSources - Pre-filtered host sources from broadcastSources
 * @returns {Array} Merged array of source-shaped objects for hosts
 */
function getHostSourcesFromRoles() {
  var broadcastRoles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var hostSources = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return mergeRolesAndSources(broadcastRoles.filter(function (role) {
    return role.role === 'director';
  }), hostSources);
}
function mergeRolesAndSources(roles, sources) {
  var roleUserIds = new Set(roles.map(function (r) {
    return r.userId;
  }));
  var sourcesFromRoles = roles.map(function (role) {
    var matchingSource = sources.find(function (s) {
      return s.user === role.userId;
    });
    var roleSource = mapRoleToSource(role);
    if (matchingSource !== null && matchingSource !== void 0 && matchingSource.title && matchingSource.title !== roleSource.title) {
      logger.info('Name change detected in source but not in roles', {
        userId: role.userId,
        rolesName: roleSource.title,
        sourceName: matchingSource.title
      });
      return _objectSpread(_objectSpread({}, roleSource), {}, {
        title: matchingSource.title
      });
    }
    return roleSource;
  });
  var extraSources = sources.filter(function (s) {
    return !roleUserIds.has(s.user);
  });
  if (extraSources.length > 0) {
    logger.info('Users found in sources but not in broadcastRoles', {
      extraUserIds: extraSources.map(function (s) {
        return s.user;
      })
    });
  }
  return [].concat(_toConsumableArray(sourcesFromRoles), _toConsumableArray(extraSources));
}

/**
 * Maps a broadcast role object to a source-shaped object.
 * Used to preserve structure for some existing logging
 *
 * @param {Object} role - A broadcast role object from usersData
 * @returns {Object} A source-shaped object with _id, role, title, type, and user
 */
function mapRoleToSource(role) {
  return {
    _id: role.id,
    role: role.role,
    title: "".concat(role.firstName, " ").concat(role.lastName).trim(),
    type: _Sources.CAMERA_PRESENTER,
    user: role.userId
  };
}